import React from 'react';
import { GardenArea } from '../../services/gardenService';
import './Garden.css';

interface GardenAreaComponentProps {
  area: GardenArea;
  plantCount: number;
}

const GardenAreaComponent: React.FC<GardenAreaComponentProps> = ({
  area,
  plantCount
}) => {
  return (
    <div
      className="garden-area"
      style={{
        left: area.position_x,
        top: area.position_y,
        width: area.width,
        height: area.height,
        backgroundColor: area.color,
        borderColor: area.color === '#f5f5f5' || area.color === '#fafafa' || area.color === '#f0f0f0'
          ? '#e0e0e0'
          : area.color
      }}
    >
      {area.year_number && (
        <div className="garden-area-year-display">
          <span className="garden-area-year-number">{area.year_number}</span>
          <span className="garden-area-age-label">{area.life_year_label}</span>

          {plantCount > 0 && (
          <span className="garden-area-plant-count">
            {plantCount} plant{plantCount !== 1 ? 's' : ''}
          </span>
        )}

        </div>
      )}
      
    </div>
  );
};

export default GardenAreaComponent;
